import React, { useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { formatCurrency, getLink } from "../../utils/helpers";

export default function DescuentoItem({descuento}) {

    const [state, setState] = useState({
        showCuotas: false,
    });

    function toggleCuotas(){
        setState({
            showCuotas: !state.showCuotas,
        });
    }

    const { showCuotas } = state;

    const ultimaCuota = descuento.cuotasCompletadas.length && dayjs(
        descuento.cuotasCompletadas[0].fecha
    ).format(
        "YYYY-MM-DD"
    );

    const proxCuota = descuento.cuotasPendientes.length && dayjs(
        descuento.cuotasPendientes[0].fecha
    ).format(
        "YYYY-MM-DD"
    );

    return (
        <div className="descuento-item" key={descuento.id}>
            <div className="descuento-row descuento-info" onClick={() => toggleCuotas()}>
                <div>
                    <strong>
                        <Link to={getLink(`/empleados/${descuento.empleadoId}/descuentos-programados`)}>{ descuento.empleado }</Link>
                    </strong>
                    {descuento.telefono && <div>
                        Tel: {descuento.telefono}
                    </div>}
                </div>
                <div>
                    <small>
                        Frecuencia: {
                            descuento.frecuencia
                        }
                    </small>
                    <div className="descuento__descripcion">
                        {
                            descuento.descripcion
                        }
                    </div>
                </div>
                <div>
                    <div><strong>{formatCurrency(descuento.montoTotal)}</strong></div>
                    # Cuotas: {descuento.cuotas?.length || 1}
                </div>
                <div>
                    <div><strong>{formatCurrency(descuento.monto)}</strong></div>
                    Pendientes: {descuento.cuotasPendientes?.length > 0 ? descuento.cuotasPendientes.length : descuento.pendientes/2 }
                </div>
                <div>
                    {descuento.cuotasCompletadas?.length > 0 && <div>
                        <strong>Último:{' '}</strong>
                        <div>
                            {ultimaCuota}
                        </div>
                    </div>}
                    {descuento.cuotasPendientes?.length > 0 && <div>
                        <strong>Próximo:{' '}</strong>
                        <div>
                            {proxCuota}
                        </div>
                    </div>}
                </div>
                <div>
                    <div className='table-data-feature'>
                        <Link
                            to={getLink(
                                `/descuentos/${descuento.id}`
                            )}
                            className='item'
                            data-toggle='tooltip'
                            data-placement='top'
                            title=''
                            data-original-title='Edit'>
                            <i className='zmdi zmdi-edit' />
                        </Link>
                        <Link
                            to={getLink(
                                `/imprimir/descuentos/${descuento.id}`
                            )}
                            className='item'
                            target='_blank'
                            data-original-title='Imprimir'>
                            <i className='zmdi zmdi-print' />
                        </Link>
                    </div>
                </div>
            </div>

            {descuento.cuotas?.length > 0 && (<div className={`descuento-cuotas ${showCuotas ? 'show' : ''}`}>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Monto</th>
                            <th>Fecha</th>
                            <th>Estado</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {descuento.cuotas.map(cuota =>
                            <tr key={cuota.id} className={`cuota ${cuota.estado}`}>
                                <td>{formatCurrency(cuota.monto)}</td>
                                <td>
                                    {dayjs(
                                        cuota.fecha
                                    ).format(
                                        "DD MMM, YYYY"
                                    )}
                                </td>
                                <td className="cuota__estado">
                                    {cuota.estado}
                                </td>
                                <td>
                                    <div className="table-data-feature">
                                        <Link
                                            to={getLink(
                                                `/descuentos/cuota/${cuota.id}`
                                            )}
                                            className='item'
                                            data-toggle='tooltip'
                                            data-placement='top'
                                            title=''
                                            data-original-title='Edit'>
                                            <i className='zmdi zmdi-edit' />
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>)}
        </div>
    );
}
